import React from "react";
import ReactDOM from  "react-dom";
import Template from "./contact_form_modal.rt";
import { contactUs } from "../../gateway/backend";


export default class ContactUsModal extends React.Component {

  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this)
    this.contactUsFormData = {};
  }

  handleChange(e) {
    this.contactUsFormData[e.target.name] = e.target.value;
  }

  onContactUsSubmit(event) {
    const form = event.target.parentElement;
    if(form.checkValidity()) {
      event.preventDefault();
      event.stopPropagation();
      contactUs(this.contactUsFormData);
      this.props.toggleContactUs()
    }
  }

  render() {
    return Template.call(this);
  }
}



// WEBPACK FOOTER //
// ./app/javascript/pages/metype_home/contact_form_modal.js